// @flow

import CardInsuranceList from './CardInsuranceList'

export default CardInsuranceList
